module.exports = __webpack_public_path__ + "assets/114231767206fb024c2be299a4128f96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/bg5.png
// module id = 385
// module chunks = 1